import { useClassNamePrefix } from "./useClassNamePrefix.js";
const useComponentClassName = (className) => {
  const prefix = useClassNamePrefix();
  return `${prefix}${className}`;
};
export {
  useComponentClassName
};
//# sourceMappingURL=useComponentClassName.js.map
